module.exports = __webpack_public_path__ + "static/media/about-of-img.2c78aed5.png";